import React, { useEffect, useRef } from "react";
import * as c3 from "c3";
import "c3/c3.css";
import * as _ from "lodash";

const C3 = ({ config }) => {
  const chartRef = useRef(null);

  const data = _.get(config, "data", {});
  const axis = _.get(config, "axis", {});
  const grid = _.get(config, "grid", {});
  const bar = _.get(config, "bar", {});
  const color = _.get(config, "color", {});
  const legend = _.get(config, "legend", {});
  const padding = _.get(config, "padding", {});
  const donut = _.get(config, "donut", {});
  const tooltip = _.get(config, "tooltip", {});

  useEffect(() => {
    const chart = c3.generate({
      bindto: chartRef.current,
      data ,
      axis,
      grid,
      bar,
      color,
      legend,
      padding,
      donut,
      tooltip,
    });

    return () => {
      chart.destroy();
    };
  }, [data, axis, grid, bar, color, legend, padding, donut, tooltip]);

  return <div ref={chartRef} />;
};

export default C3;
